module.exports = __webpack_public_path__ + "img/machineConversation.b0c96a44.png";